import { adminApi } from './api';

// FAQ API
export const getFaqPosts = async (params) => {
  const response = await adminApi.get('/api/admin/faq', { params });
  return response.data?.data ?? response.data;
};

export const getFaqDetail = async (postId) => {
  const response = await adminApi.get(`/api/admin/faq/${postId}`);
  return response.data?.data ?? response.data;
};

export const createFaqPost = async (data) => {
  const response = await adminApi.post('/api/admin/faq', data);
  return response.data?.data ?? response.data;
};

export const updateFaqPost = async (postId, data) => {
  const response = await adminApi.put(`/api/admin/faq/${postId}`, data);
  return response.data?.data ?? response.data;
};

export const deleteFaqPost = async (postId) => {
  const response = await adminApi.delete(`/api/admin/faq/${postId}`);
  return response.data?.data ?? response.data;
};

// Library API
export const getLibraryPosts = async (params) => {
  const response = await adminApi.get('/api/admin/library', { params });
  return response.data?.data ?? response.data;
};

export const createLibraryPost = async (data) => {
  const { categoryId, title, content, file } = data;
  if (!file) {
    throw new Error('첨부파일은 필수입니다.');
  }
  const formData = new FormData();
  formData.append('request', new Blob([JSON.stringify({ categoryId, title, content })], { type: 'application/json' }));
  formData.append('file', file);
  const response = await adminApi.post('/api/admin/library', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data?.data ?? response.data;
};

export const getLibraryDetail = async (postId) => {
  const response = await adminApi.get(`/api/admin/library/${postId}`);
  return response.data?.data ?? response.data;
};

export const downloadLibraryFile = async (postId) => {
  const response = await adminApi.get(`/api/admin/library/${postId}/download`, {
    responseType: 'blob',
  });
  return response;
};

export const updateLibraryPost = async (postId, data) => {
  const { categoryId, title, content, file } = data;
  if (file) {
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify({ categoryId, title, content })], { type: 'application/json' }));
    formData.append('file', file);
    const response = await adminApi.put(`/api/admin/library/${postId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data?.data ?? response.data;
  }
  const payload = { title, content };
  if (categoryId != null) payload.categoryId = categoryId;
  const response = await adminApi.put(`/api/admin/library/${postId}`, payload);
  return response.data?.data ?? response.data;
};

export const deleteLibraryPost = async (postId) => {
  const response = await adminApi.delete(`/api/admin/library/${postId}`);
  return response.data?.data ?? response.data;
};